import { gql, useQuery } from '@apollo/client';

import { BillProjectHoursRequestFilter } from '@work4all/models/lib/Classes/BillProjectHoursRequestFilter.entity';

const QUERY = gql`
  query getNumberOfProjectHours($filters: BillProjectHoursRequestFilter!) {
    getNumberOfProjecthours(filters: $filters)
  }
`;

type QueryRequest = {
  filters: BillProjectHoursRequestFilter;
};

type QueryResponse = {
  getNumberOfProjecthours: number;
};

export const useNumberOfProjectHours = (
  filters: BillProjectHoursRequestFilter
) => {
  const response = useQuery<QueryResponse, QueryRequest>(QUERY, {
    variables: { filters },
  });

  return response.data?.getNumberOfProjecthours ?? 0;
};
